import { PayloadAction } from '@reduxjs/toolkit';
import { SyfoAppState } from '../state';
import { SavingsNode } from '@syfo/types/vault.types';
import { updateById } from './reducer-utils';

export const addSavings = (state: SyfoAppState, action: PayloadAction<SavingsNode>) => {
  if (state.currentVault) {
    state.currentVault.data.savings.push(action.payload);
  }
};

export const updateSavings = (state: SyfoAppState, action: PayloadAction<{ id: string; savings: Partial<SavingsNode> }>) => {
  if (state.currentVault) {
    updateById(state.currentVault.data.savings, action.payload.id, action.payload.savings);
  }
};

export const removeSavings = (state: SyfoAppState, action: PayloadAction<string>) => {
  if (state.currentVault) {
    state.currentVault.data.savings = state.currentVault.data.savings.filter(s => s.id !== action.payload);
  }
};
